// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IAgentBonusSchema } from '../agent_bonus/AgentBonusSchema';
import type { IPricePresenterSchema } from '../price_presenter/PricePresenterSchema';
import type { IUtilitiesTermsSchema } from '../utilities_terms/UtilitiesTermsSchema';

export interface IBargainTermsPresenterSchema {
  /** Бонус агентам **/
  agentBonus?: IAgentBonusSchema;
  /** Комиссия от другого агента, %% **/
  agentFee?: number;
  /** Возможен торг **/
  bargainAllowed?: boolean;
  /** Условия торга **/
  bargainConditions?: string;
  /** Цена с учетом торга **/
  bargainPrice?: number;
  /** Цена с учетом торга **/
  bargainPricePrices?: IPricePresenterSchema;
  /** Комиссия от прямого клиента, %% **/
  clientFee?: number;
  /** Тип договора **/
  contractType?: EContractType;
  /** Валюта **/
  currency?: ECurrency;
  /** Залог собственнику **/
  deposit?: number;
  /** Залог собственнику **/
  depositPrices?: IPricePresenterSchema;
  /** Арендные каникулы **/
  hasGracePeriod?: boolean;
  /** Включено в ставку **/
  includedOptions?: EIncludedOptions[];
  /** Срок аренды **/
  leaseTermType?: ELeaseTermType;
  /** Тип аренды **/
  leaseType?: ELeaseType;
  /** Минимальный срок аренды, мес **/
  minLeaseTerm?: number;
  /** Ипотека **/
  mortgageAllowed?: boolean;
  /** Период оплаты **/
  paymentPeriod?: EPaymentPeriod;
  /** Предоплата **/
  prepayMonths?: number;
  /** Цена **/
  price?: number;
  /** Цена в евро **/
  priceEur?: number;
  /** Цена за рабочее место **/
  priceForWorkplace?: number;
  /** Цена в рублях **/
  priceRur?: number;
  /** Тип цены **/
  priceType?: EPriceType;
  /** Цена в долларах **/
  priceUsd?: number;
  /** Тип продажи **/
  saleType?: ESaleType;
  /** Обеспечительный платеж **/
  securityDeposit?: number;
  /** Обеспечительный платеж **/
  securityDepositPrices?: IPricePresenterSchema;
  /** Состав съемщиков **/
  tenantsType?: ETenantsType;
  /** Коммунальные услуги **/
  utilitiesTerms?: IUtilitiesTermsSchema;
  /** Коммунальные услуги **/
  utilitiesTermsPrices?: IPricePresenterSchema;
  /** НДС включен (deprecated) **/
  vatIncluded?: boolean;
  /** Сумма налога **/
  vatPrice?: number;
  /** Сумма налога **/
  vatPrices?: IPricePresenterSchema;
  /** НДС **/
  vatType?: EVatType;
}
export enum EContractType {
  /** Переуступка прав аренды **/
  'LeaseAssignment' = 'leaseAssignment',
  /** Продажа **/
  'Sale' = 'sale',
}
export enum ECurrency {
  /** € **/
  'Eur' = 'eur',
  /** руб. **/
  'Rur' = 'rur',
  /** $ **/
  'Usd' = 'usd',
}
export enum EIncludedOptions {
  /** Операционные расходы **/
  'OperationalCosts' = 'operationalCosts',
  /** Коммунальные платежи **/
  'UtilityCharges' = 'utilityCharges',
}
export enum ELeaseTermType {
  /** На несколько месяцев **/
  'FewMonths' = 'fewMonths',
  /** Длительный **/
  'LongTerm' = 'longTerm',
}
export enum ELeaseType {
  /** Прямая аренда **/
  'Direct' = 'direct',
  /** Договор совместной деятельности **/
  'JointVenture' = 'jointVenture',
  /** Субаренда **/
  'Sublease' = 'sublease',
}
export enum EPaymentPeriod {
  /** За год **/
  'Annual' = 'annual',
  /** За месяц **/
  'Monthly' = 'monthly',
}
export enum EPriceType {
  /** Цена за все **/
  'All' = 'all',
  /** Цена за гектар **/
  'Hectare' = 'hectare',
  /** Цена за сотку **/
  'Sotka' = 'sotka',
  /** Цена за квадратный метр **/
  'SquareMeter' = 'squareMeter',
}
export enum ESaleType {
  /** Альтернатива **/
  'Alternative' = 'alternative',
  /** Договор уступки права требования **/
  'Dupt' = 'dupt',
  /** Договор ЖСК **/
  'Dzhsk' = 'dzhsk',
  /** Свободная продажа **/
  'Free' = 'free',
  /** 214-ФЗ **/
  'Fz214' = 'fz214',
  /** Договор инвестирования **/
  'Investment' = 'investment',
  /** Предварительный договор купли-продажи **/
  'Pdkp' = 'pdkp',
}
export enum ETenantsType {
  /** Любой **/
  'Any' = 'any',
  /** Семья **/
  'Family' = 'family',
  /** Женщина **/
  'Female' = 'female',
  /** Мужчина **/
  'Male' = 'male',
}
export enum EVatType {
  /** НДС включен **/
  'Included' = 'included',
  /** НДС не включен **/
  'NotIncluded' = 'notIncluded',
  /** УСН (упрощенная система налогообложения) **/
  'Usn' = 'usn',
}
